import { createClient, type SupabaseClient } from '@supabase/supabase-js';

import { env } from '@/config/env';

let client: SupabaseClient | null = null;

/**
 * Anonymous client. It can read only the public_vehicle_* views; there is no
 * visitor sign-in (§21), so no session is stored.
 */
export function getSupabase(): SupabaseClient {
  if (client) return client;
  if (!env.supabaseUrl || !env.supabaseAnonKey) {
    throw new Error(
      'Supabase is not configured: set VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY (see .env.example).',
    );
  }
  client = createClient(env.supabaseUrl, env.supabaseAnonKey, {
    auth: { persistSession: false, autoRefreshToken: false, detectSessionInUrl: false },
  });
  return client;
}
